// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__2tNSo","Label":"Checkbox_Label__1xPoZ","InputElement":"Checkbox_InputElement__3geFf","Invalid":"Checkbox_Invalid__2AQ5E"};